import { render, staticRenderFns } from "./ValidationForm.vue?vue&type=template&id=ed08b5e8&"
import script from "./ValidationForm.vue?vue&type=script&lang=ts&"
export * from "./ValidationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports